import * as Articles from 'cityads-v3/articles';

export function getArticleClass(articleClass) {
  if (typeof articleClass === 'string') {
    return Articles[articleClass];
  }

  return articleClass;
}

export function hasMore({ moreText, moreElem, articleClass, moreLink }) {
  return Boolean((moreText || moreElem || getArticleClass(articleClass)) && moreLink)
}
